import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FaSignOutAlt } from "react-icons/fa";
import logo from "../Components/Pages/Images/SMJ_Logo.png";
import "./Navbar.css";
import { AuthContext } from "../Components/Pages/Login/Context";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import baseURL from "../Url/NodeBaseURL";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [mastersDropdownOpen, setMastersDropdownOpen] = useState(false);
  const [transactionsDropdownOpen, setTransactionsDropdownOpen] =
    useState(false);
  const [reportsDropdownOpen, setReportsDropdownOpen] = useState(false);
  const [utilityDropdownOpen, setUtilityDropdownOpen] = useState(false);
  const { authToken, userId, userName } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) return;

        const response = await fetch(
          `${baseURL}/permissions/${user.user_type_id}`,
        );
        if (!response.ok) throw new Error("Failed to fetch permissions");

        const perms = await response.json();
        // console.log('All permissions:', perms);
        // console.log('User Master permissions:', perms.permissions['User Master']);

        // Set the nested permissions object, not the entire response
        setPermissions(perms.permissions);
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermissions();
  }, []);

  const shouldShowMenuItem = (permissionKey) => {
    // console.log(`Checking ${permissionKey}:`, permissions[permissionKey]?.view);
    return permissions[permissionKey]?.view === true;
  };

  useEffect(() => {
    if (location.pathname !== "/purchase") {
      localStorage.removeItem("tableData");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname !== "/orders") {
      localStorage.removeItem("orderDetails");
      localStorage.removeItem("paymentDetails");
      localStorage.removeItem("oldTableData");
      localStorage.removeItem("schemeTableData");
      localStorage.removeItem(`discount`);
    }
  }, [location.pathname]);

  const getTabId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let tabId = urlParams.get("tabId");

    if (!tabId) {
      tabId = sessionStorage.getItem("tabId");
    }

    if (!tabId) {
      tabId = uuidv4(); // ✅ Replaced crypto.randomUUID() with uuidv4()
      sessionStorage.setItem("tabId", tabId);
      const newUrl = `${window.location.pathname}?tabId=${tabId}`;
      window.history.replaceState({}, "", newUrl);
    }

    return tabId;
  };

  const tabId = getTabId();

  const toggleMenu = () => setIsOpen(!isOpen);

  // const toggleDropdown = (dropdownType) => {
  //   switch (dropdownType) {
  //     case 'masters': setMastersDropdownOpen(!mastersDropdownOpen); break;
  //     case 'transactions': setTransactionsDropdownOpen(!transactionsDropdownOpen); break;
  //     case 'reports': setReportsDropdownOpen(!reportsDropdownOpen); break;
  //     case 'utility': setUtilityDropdownOpen(!utilityDropdownOpen); break;
  //     default: break;
  //   }
  // };

  const openDropdown = (type) => {
    if (type === "masters") setMastersDropdownOpen(true);
    if (type === "transactions") setTransactionsDropdownOpen(true);
    if (type === "reports") setReportsDropdownOpen(true);
    if (type === "utility") setUtilityDropdownOpen(true);
  };

  const closeDropdown = (type) => {
    if (type === "masters") setMastersDropdownOpen(false);
    if (type === "transactions") setTransactionsDropdownOpen(false);
    if (type === "reports") setReportsDropdownOpen(false);
    if (type === "utility") setUtilityDropdownOpen(false);
  };

  const handleItemClick = () => {
    setMastersDropdownOpen(false);
    setTransactionsDropdownOpen(false);
    setReportsDropdownOpen(false);
    setUtilityDropdownOpen(false);
    setIsOpen(false);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log out!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/");
      }
    });
  };

  const isActive = (path) => (location.pathname === path ? "active" : "");
  const userRole = localStorage.getItem("userRole");

  return (
    <header className="navbar-header">
      <div className="navbar-brand">
        <img src={logo} alt="Logo" style={{ width: "85px", height: "60px" }} />
      </div>

      {/* Mobile Controls - Hamburger and Logout side by side */}
      <div className="mobile-controls d-lg-none">
        {/* Mobile Logout Button */}

        {/* Bootstrap Navbar Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
          <span className="navbar-toggler-icon"></span>
          <span className="navbar-toggler-icon"></span>
        </button>

        <button className="mobile-logout-btn" onClick={handleLogout}>
          <FaSignOutAlt size={18} />
        </button>
      </div>

      {/* Main Navigation */}
      <nav className={`navbar-links ${isOpen ? "open" : ""} d-none d-lg-flex`}>
        <div>
          <span>
            <Link
              to="/dashboard"
              onClick={handleItemClick}
              style={{
                color:
                  window.location.pathname === "/dashboard"
                    ? "#a36e29"
                    : "black",
                textDecoration: "none",
                backgroundColor: "transparent",
              }}
            >
              DASHBOARD
            </Link>
          </span>
        </div>

        {/* Masters Dropdown */}
        <div
          className="navbar-dropdown"
          onMouseEnter={() => openDropdown("masters")}
          onMouseLeave={() => closeDropdown("masters")}
        >
          <span className="navbar-dropdown-title">
            MASTERS{" "}
            <FontAwesomeIcon
              icon={mastersDropdownOpen ? faChevronUp : faChevronDown}
            />
          </span>
          {mastersDropdownOpen && (
            <div className="navbar-dropdown-content">
              {userRole === "admin" && (
                <Link
                  to="/usertable"
                  onClick={handleItemClick}
                  className={isActive("/usertable")}
                >
                  User Master
                </Link>
              )}
              {userRole === "admin" && (
                <Link
                  to="/userrole"
                  onClick={handleItemClick}
                  className={isActive("/userrole")}
                >
                  User Profile
                </Link>
              )}
              {shouldShowMenuItem("Customer Master") && (
                <Link
                  to="/customerstable"
                  onClick={handleItemClick}
                  className={
                    isActive("/customerstable") || isActive("/customermaster")
                  }
                >
                  Customer Master
                </Link>
              )}
              {/* {shouldShowMenuItem('Worker Master') && (
                <Link to="/workerstable" onClick={handleItemClick} className={isActive('/workerstable') || isActive('/workermaster')}>Worker Master</Link>
              )} */}
              {shouldShowMenuItem("Accounts") && (
                <Link
                  to="/accountstable"
                  onClick={handleItemClick}
                  className={
                    isActive("/accountstable") || isActive("/accounts")
                  }
                >
                  Accounts
                </Link>
              )}
              {shouldShowMenuItem("Category Master") && (
                <Link
                  to="/itemmastertable"
                  onClick={handleItemClick}
                  className={
                    isActive("/itemmastertable") || isActive("/itemmaster")
                  }
                >
                  Category Master
                </Link>
              )}
              {shouldShowMenuItem("Sub Category Master") && (
                <Link
                  to="/subcategorytable"
                  onClick={handleItemClick}
                  className={
                    isActive("/subcategorytable") || isActive("/subcategory")
                  }
                >
                  Sub Category Master
                </Link>
              )}
              {shouldShowMenuItem("Purity") && (
                <Link
                  to="/purity"
                  onClick={handleItemClick}
                  className={isActive("/purity")}
                >
                  Purity
                </Link>
              )}
              {shouldShowMenuItem("Metal Type") && (
                <Link
                  to="/metaltype"
                  onClick={handleItemClick}
                  className={isActive("/metaltype")}
                >
                  Metal Type
                </Link>
              )}
              {shouldShowMenuItem("Design Master") && (
                <Link
                  to="/designmaster"
                  onClick={handleItemClick}
                  className={isActive("/designmaster")}
                >
                  Design Master
                </Link>
              )}
              {shouldShowMenuItem("Rates") && (
                <Link
                  to="/rates"
                  onClick={handleItemClick}
                  className={isActive("/rates")}
                >
                  Rates
                </Link>
              )}
              {shouldShowMenuItem("Wastage Master") && (
                <Link
                  to="/wastagemaster"
                  onClick={handleItemClick}
                  className={isActive("/wastagemaster")}
                >
                  Wastage Master
                </Link>
              )}
              {shouldShowMenuItem("Company Info") && (
                <Link
                  to="/company_info"
                  onClick={handleItemClick}
                  className={isActive("/company_info")}
                >
                  Company Info
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Transactions Dropdown */}
        <div
          className="navbar-dropdown"
          onMouseEnter={() => openDropdown("transactions")}
          onMouseLeave={() => closeDropdown("transactions")}
        >
          <span className="navbar-dropdown-title">
            TRANSACTIONS{" "}
            <FontAwesomeIcon
              icon={transactionsDropdownOpen ? faChevronUp : faChevronDown}
            />
          </span>
          {transactionsDropdownOpen && (
            <div className="navbar-dropdown-content">
              {shouldShowMenuItem("Sales") && (
                <Link
                  to="/salestable"
                  onClick={handleItemClick}
                  className={isActive("/salestable") || isActive("/sales")}
                >
                  Sales
                </Link>
              )}
              {shouldShowMenuItem("Estimate") && (
                <Link
                  to="/estimatetable"
                  onClick={handleItemClick}
                  className={
                    isActive("/estimatetable") || isActive("/estimates")
                  }
                >
                  Estimate
                </Link>
              )}
              {shouldShowMenuItem("Stock") && (
                <Link
                  to="/stockEntryTable"
                  onClick={handleItemClick}
                  className={isActive("/stockEntryTable")}
                >
                  Stock
                </Link>
              )}
              {shouldShowMenuItem("Reciepts") && (
                <Link
                  to="/receiptstable"
                  onClick={handleItemClick}
                  className={
                    isActive("/receiptstable") || isActive("/receipts")
                  }
                >
                  Receipts
                </Link>
              )}
              {shouldShowMenuItem("Stock Entry") && (
                <Link
                  to="/purchasetable"
                  onClick={handleItemClick}
                  className={
                    isActive("/purchasetable") || isActive("/purchase")
                  }
                >
                  Stock Entry
                </Link>
              )}
              {shouldShowMenuItem("Repairs") && (
                <Link
                  to="/repairstable"
                  onClick={handleItemClick}
                  className={isActive("/repairstable") || isActive("/repairs")}
                >
                  Repairs
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Reports Dropdown */}
        <div
          className="navbar-dropdown"
          onMouseEnter={() => openDropdown("reports")}
          onMouseLeave={() => closeDropdown("reports")}
        >
          <span className="navbar-dropdown-title">
            REPORTS{" "}
            <FontAwesomeIcon
              icon={reportsDropdownOpen ? faChevronUp : faChevronDown}
            />
          </span>
          {reportsDropdownOpen && (
            <div className="navbar-dropdown-content">
              <Link
                to="/stockReport"
                onClick={handleItemClick}
                className={isActive("/stockReport")}
              >
                Stock Report
              </Link>
              <Link
                to="/inventoryReport"
                onClick={handleItemClick}
                className={isActive("/inventoryReport")}
              >
                Detailed Stock Report
              </Link>
              <Link
                to="/salesReport"
                onClick={handleItemClick}
                className={isActive("/salesReport")}
              >
                Sales Report
              </Link>
              <Link
                to="/detailedsalesReport"
                onClick={handleItemClick}
                className={isActive("/detailedsalesReport")}
              >
                Detailed Sales Report
              </Link>
              <Link
                to="/salesBalanceReport"
                onClick={handleItemClick}
                className={isActive("/salesBalanceReport")}
              >
                Customer Balance Report
              </Link>
              <Link
                to="/estimateReport"
                onClick={handleItemClick}
                className={isActive("/estimateReport")}
              >
                Estimate Report
              </Link>
              <Link
                to="/repairsReport"
                onClick={handleItemClick}
                className={isActive("/repairsReport")}
              >
                Repairs Report
              </Link>
              <Link
                to="/ratesdata"
                onClick={handleItemClick}
                className={isActive("/ratesdata")}
              >
                Rates Report
              </Link>
            </div>
          )}
        </div>

        {/* Page Heading */}
        <div className="d-none d-xl-block">
          <span>
            {(location.pathname === "/sales" ||
              location.pathname === "/salestable") && (
              <h1 className="path-heading">SALES</h1>
            )}
            {(location.pathname === "/purchase" ||
              location.pathname === "/purchasetable") && (
              <h1 className="path-heading">STOCK ENTRY</h1>
            )}
            {(location.pathname === "/subcategory" ||
              location.pathname === "/subcategorytable") && (
              <h1 className="path-heading">SUB CATEGORY</h1>
            )}
            {(location.pathname === "/customermaster" ||
              location.pathname === "/customerstable") && (
              <h1 className="path-heading">CUSTOMERS</h1>
            )}
            {(location.pathname === "/usertable" ||
              location.pathname === "/usermaster") && (
              <h1 className="path-heading">USER</h1>
            )}
            {location.pathname === "/userrole" && (
              <h1 className="path-heading">USER ROLE</h1>
            )}
          </span>
        </div>
      </nav>

      {/* Mobile Navigation */}
      <div className={`mobile-nav-links d-lg-none ${isOpen ? "open" : ""}`}>
        <div className="mobile-nav-item">
          <Link
            to="/dashboard"
            onClick={handleItemClick}
            className="mobile-nav-link"
          >
            DASHBOARD
          </Link>
        </div>

        {/* Mobile Masters Dropdown */}
        <div className="mobile-nav-dropdown">
          <span
            className="mobile-nav-dropdown-title"
            onMouseEnter={() => openDropdown("masters")}
            onMouseLeave={() => closeDropdown("masters")}
          >
            MASTERS{" "}
            <FontAwesomeIcon
              icon={mastersDropdownOpen ? faChevronUp : faChevronDown}
            />
          </span>
          {mastersDropdownOpen && (
            <div className="mobile-nav-dropdown-content">
              {userRole === "admin" && (
                <Link
                  to="/usertable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  User Master
                </Link>
              )}
              {userRole === "admin" && (
                <Link
                  to="/userrole"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  User Profile
                </Link>
              )}
              {shouldShowMenuItem("Customer Master") && (
                <Link
                  to="/customerstable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Customer Master
                </Link>
              )}
              {/* {shouldShowMenuItem('Worker Master') && <Link to="/workerstable" onClick={handleItemClick} className="mobile-nav-link">Worker Master</Link>} */}
              {shouldShowMenuItem("Accounts") && (
                <Link
                  to="/accountstable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Accounts
                </Link>
              )}
              {shouldShowMenuItem("Category Master") && (
                <Link
                  to="/itemmastertable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Category Master
                </Link>
              )}
              {shouldShowMenuItem("Sub Category Master") && (
                <Link
                  to="/subcategorytable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Sub Category Master
                </Link>
              )}
              {shouldShowMenuItem("Purity") && (
                <Link
                  to="/purity"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Purity
                </Link>
              )}
              {shouldShowMenuItem("Metal Type") && (
                <Link
                  to="/metaltype"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Metal Type
                </Link>
              )}
              {shouldShowMenuItem("Design Master") && (
                <Link
                  to="/designmaster"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Design Master
                </Link>
              )}
              {shouldShowMenuItem("Rates") && (
                <Link
                  to="/rates"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Rates
                </Link>
              )}
              {shouldShowMenuItem("Wastage Master") && (
                <Link
                  to="/wastagemaster"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Wastage Master
                </Link>
              )}
              {shouldShowMenuItem("Company Info") && (
                <Link
                  to="/company_info"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Company Info
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Mobile Transactions Dropdown */}
        <div className="mobile-nav-dropdown">
          <span
            className="mobile-nav-dropdown-title"
            onMouseEnter={() => openDropdown("transactions")}
            onMouseLeave={() => closeDropdown("transactions")}
          >
            TRANSACTIONS{" "}
            <FontAwesomeIcon
              icon={transactionsDropdownOpen ? faChevronUp : faChevronDown}
            />
          </span>
          {transactionsDropdownOpen && (
            <div className="mobile-nav-dropdown-content">
              {shouldShowMenuItem("Sales") && (
                <Link
                  to="/salestable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Sales
                </Link>
              )}
              {shouldShowMenuItem("Estimate") && (
                <Link
                  to="/estimatetable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Estimate
                </Link>
              )}
              {shouldShowMenuItem("Stock") && (
                <Link
                  to="/stockEntryTable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Stock
                </Link>
              )}
              {shouldShowMenuItem("Reciepts") && (
                <Link
                  to="/receiptstable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Receipts
                </Link>
              )}
              {shouldShowMenuItem("Stock Entry") && (
                <Link
                  to="/purchasetable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Stock Entry
                </Link>
              )}
              {shouldShowMenuItem("Repairs") && (
                <Link
                  to="/repairstable"
                  onClick={handleItemClick}
                  className="mobile-nav-link"
                >
                  Repairs
                </Link>
              )}
            </div>
          )}
        </div>

        {/* Mobile Reports Dropdown */}
        <div className="mobile-nav-dropdown">
          <span
            className="mobile-nav-dropdown-title"
            onMouseEnter={() => openDropdown("reports")}
            onMouseLeave={() => closeDropdown("reports")}
          >
            REPORTS{" "}
            <FontAwesomeIcon
              icon={reportsDropdownOpen ? faChevronUp : faChevronDown}
            />
          </span>
          {reportsDropdownOpen && (
            <div className="mobile-nav-dropdown-content">
              <Link
                to="/stockReport"
                onClick={handleItemClick}
                className="mobile-nav-link"
              >
                Stock Report
              </Link>
              <Link
                to="/inventoryReport"
                onClick={handleItemClick}
                className="mobile-nav-link"
              >
                Detailed Stock Report
              </Link>
              <Link
                to="/salesReport"
                onClick={handleItemClick}
                className="mobile-nav-link"
              >
                Sales Report
              </Link>
              <Link
                to="/salesBalanceReport"
                onClick={handleItemClick}
                className="mobile-nav-link"
              >
                Customer Balance Report
              </Link>
              <Link
                to="/estimateReport"
                onClick={handleItemClick}
                className="mobile-nav-link"
              >
                Estimate Report
              </Link>
              <Link
                to="/repairsReport"
                onClick={handleItemClick}
                className="mobile-nav-link"
              >
                Repairs Report
              </Link>
              <Link
                to="/ratesdata"
                onClick={handleItemClick}
                className="mobile-nav-link"
              >
                Rates Report
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="username d-none d-md-block">{userName}</div>

      {/* Desktop Logout Button */}
      <div className="navbar-logout d-none d-lg-block">
        <button className="logout-button" onClick={handleLogout}>
          <FaSignOutAlt size={18} />{" "}
          <span className="d-none d-sm-inline">Logout</span>
        </button>
      </div>
    </header>
  );
}

export default Navbar;
